import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';

import {containers as AuthContainers} from '../modules/auth';
import {containers as BaseContainers} from '../modules/core';
import {containers as LandingContainer} from '../modules/landing';
import EmailConfirmContainer from '../modules/blocks/EmailConfirmation';
import {containers as CategoriesContainer} from '../modules/categories';
import NotFound from 'modules/blocks/404'
import EmailConfirmation from 'modules/blocks/EmailConfirmation';
import SearchComponent from 'modules/search/SearchComponent';
import AboutUs from 'modules/informations/AboutUs';
import ContactUs from 'modules/informations/ContactUs';
import TermsOfService from 'modules/informations/TermsOfService';
import PrivacyPolicy from 'modules/informations/PrivacyPolicy';
import CookiesPolicy from 'modules/informations/CookiesPolicy';
import LiveEvents from 'modules/informations/LiveEvents';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import customBaseTheme from 'modules/theme/customBaseTheme';
import {containers as TopicContainer} from '../modules/topic';
import {containers as SamplePodcastsContainer} from '../modules/samplePodcasts';

const {
  SignUpForm,
  SignInForm,
  ResetFormEmail,
  ResetFormPassword,
  FacebookCallback
} = AuthContainers;

const {
  Header,
  Sidebar
} = BaseContainers;

const {
  Landing
} = LandingContainer;

const {
    Categories
} = CategoriesContainer;

const {
  Topic,
  TopicsList
} = TopicContainer;

const {
  SamplePodcastsList,
} = SamplePodcastsContainer;


export default class extends Component {
  render() {
    return (
    <MuiThemeProvider muiTheme={getMuiTheme(customBaseTheme)} key={3}>
      <div className="public-wrap">
        <Header/>
        <Switch>
          <Route path="/categories" component={Categories}/>
          <Route path="/signUp" component={SignUpForm}/>
          <Route path="/signIn" component={SignInForm}/>
          <Route path="/resetFormEmail" component={ResetFormEmail}/>
          <Route path="/emailConfirm" component={EmailConfirmContainer}/>
          <Route path="/facebookauthcallback" component={FacebookCallback}/>
          <Route path="/resetFormPassword/token=:token" component={ResetFormPassword}/>
          <Route path="/notfound" component={NotFound}/>
          <Route path="/aboutus" component={AboutUs}/>
          <Route path="/contactus" component={ContactUs}/>
          <Route path="/terms-of-service" component={TermsOfService}/>
          <Route path="/privacy-policy" component={PrivacyPolicy}/>
          <Route path="/cookies-policy" component={CookiesPolicy}/>
          <Route path="/emailsent/:email" component={EmailConfirmation}/>
          <Route path="/pricing" component={Landing}/>
          <Route path="/search/:title?" component={SearchComponent}/>
          <Route path="/" component={Landing} exact/>
          <Route path="/live-events" component={LiveEvents} exact/>
          <Route path="/topics" component={TopicsList} exact/>
          <Route path="/topic/:id" component={Topic} />
          <Route path="/sample-podcasts" component={SamplePodcastsList} exact />
          <Redirect to="/notfound"/>
        </Switch>
        <Sidebar/>
      </div>
    </MuiThemeProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/public.js